import React, { useMemo } from 'react';
import useResourceLoader from '../util/useResourceLoader';
import UWEEntityApi from '../api/UWEEntityApi';
import Loader from '../components/Loader';

const CURRENT = "current";
const COMPLETE = "complete";
const FINISHED = "finished";
const PROGRESS_CLASSES = {
    current: 'current_state',
    complete: 'complete_state',
    finished: 'complete_state is-last-state'
};

function UWEEntityProgress({ entity }) {

    const [ENTITY_STEPS, loadingSteps] = useResourceLoader(
        () => UWEEntityApi.getUWEEntityPreviousLog({ entityId: entity.id }),
        [entity],
        []
    );

    return loadingSteps ? <Loader /> : (
        ENTITY_STEPS?.map((step, idx) => <ProgressStep
            key={idx} step={step} entity={entity}
        />)
    )
}


function ProgressStep({ entity, step }) {

    const className = "";

    const classProgress = useMemo(() => {

        const { status = [], state = {} } = entity || {};

        if (step.steps?.includes(status?.[0]?.name) && status?.[0]?.type === "end") {
            return FINISHED;
        } else if (step.steps?.includes(status?.[0]?.name)) {
            return CURRENT;
        } else {
            return COMPLETE;
        }
    }, [step, entity]);

    return <div className={`rowProgress ${className || ''} ${PROGRESS_CLASSES[classProgress] || ""}`}>{step.group}</div>
}

export default UWEEntityProgress;